import styled, { css } from "styled-components";
import UploadInput from "../UploadInput/UploadInput";

export const UploadButtonRoot = styled(UploadInput)(
    () => css`
        &.FormControl:not(.full-width) {
            align-self: unset;
        }
    `,
) as typeof UploadInput;
